import { Stack } from '@mui/material';
import Step from '/@/components/bayer/step';
import type { RecommendationSidebarProps } from '/@/types/recommendation-create';

function RecommendationDesktopSidebar({ steps, activeStep, setActiveStep }: RecommendationSidebarProps) {
    return (
        <Stack width='max-content' maxWidth={390} borderRight={'1px solid lightgray'} height='100%' overflow='scroll'>
            {steps.map((step, i) => (
                <Step
                    key={step.sidebarName || i}
                    index={i + 1}
                    active={activeStep < i + 1}
                    name={step.sidebarName}
                    summary={activeStep > i ? step.sidebarSummary : undefined}
                    onClick={() => setActiveStep(i)}
                    disabled={activeStep < i}
                />
            ))}
        </Stack>
    );
}

export default RecommendationDesktopSidebar;
